<template>
  <v-card  class="d-flex align-center my-0 py-2 px-4"  elevation="0">
    <div style="width: 100%">
      <v-card-title class="card-title pl-0">
        <v-icon v-if="arrow" class="card-title pr-2" @click="voltar" color="#BC0000"
          >mdi-arrow-left</v-icon
        >
        <b :style="!arrow ? 'margin-left: 15px' : ''"> {{ title }}</b>
      </v-card-title>
      <v-card-text style="width: 100%" class="card-text">{{ text }} </v-card-text>
    </div>

    <div >
      <div class="d-flex-column container" >
        <!--<v-btn
          class="config black&#45;&#45;text header-button hidden-sm-and-down align-items-center pl-0 max-width: 145px"
          v-if="haveAction"
          elevation="0"
          @click="action3"
          ><v-icon color="#2D3038" class="pr-1">mdi-cog</v-icon>
          Configurações de usuários
        </v-btn>-->

        <v-btn
          fab
          tile
          small
          style="box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1)"
          class="header-button hidden-md-and-up"
          v-if="haveAction"
          color=""
          elevation="2"
          @click="action3"
        >
          <v-icon>mdi-cog</v-icon></v-btn
        >
      </div>

      <div class="d-flex-column container">
        <v-btn
          class="header-button hidden-sm-and-down align-items-center pl-0 max-width: 145px"
          style="border-radius: 10px width: 200px"
          v-if="haveAction"
          color="#2D3038"
          elevation="0"
          @click="action"
          >{{ actionTitle }}</v-btn
        >

        <v-btn
          fab
          tile
          small
          style="border-radius: 6px box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);"
          class="header-button hidden-md-and-up"
          v-if="haveAction"
          color="normalred"
          elevation="2"
          @click="action"
        >
          <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>
    </div>
  </v-card>
</template>

<style scoped>
.card-title {
  font-family: Roboto;
  font-size: 1.5rem !important;
}

.card-text {
  display: flex;
  justify-content: space-between;

  font-family: Roboto;
  font-size: 1rem;
  font-weight: 300;
  line-height: 30px;

  width: 70%;

  color: #9c9c9c;
}
.v-btn {
  font-weight: bold;
  width: 250px;
  border-radius: 10px;
  height: 45px;
}

.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 45px;
}

@media (max-width: 900px) {
  .card-title {
    font-family: Roboto;
    font-size: 1.3rem !important;
    padding: 0;
  }

  .card-text {
    font-size: 0.9rem !important;
    width: 80%;
  }
}
</style>

<script>
export default {
  name: "HeaderCard",

  data: () => ({}),
  props: {
    arrow: Boolean,
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
    mainPage: Boolean,
  },

  methods: {
    action() {
      this.$emit("action");
    },

    action2() {
      this.$emit("action2");
    },

    action3() {
      this.$emit("action3");
    },

    voltar() {
      this.$emit("voltar");
    },
  },
};
</script>
